// import MovieService from "@/services/MovieService";
import Vue from "vue";
import VueRouter from "vue-router";
import { router } from "@/router";
import store from "../../store";

const state = {
  booking_id: "",
  booking_details: []
};

const mutations = {
  SET_BOOKING_ID: (state, payload) => {
    state.booking_id = payload;
  },
  SET_BOOKING_DETAILS: (state, payload) => {
    state.booking_details = payload;
  }
};

const actions = {
  payment: async (context, payload) => {
    console.log("payload :", payload);
    // console.log('payload.cust_id :', payload.cust_id);
    // console.log('payload.reservationId :', payload.reservationId);
    let loader = Vue.$loading.show();
    await MovieService.paymentGateway({
      reserveID: payload.reservationId
    })
      .then(async response => {
        const { data } = response;
        // loader.hide();
        if (data.status) {
          if (data.Records) {
            console.log("data.Records :", data.Records);
            await context.dispatch("bookSeats", {
              reservationId: payload.reservationId,
              payment_method: data.Records,
              cust_id: payload.cust_id,
              email: payload.email,
              totalTicketPrice: payload.total,
              country_mob_code: payload.country_mob_code,
              cust_mobile: payload.cust_mobile
            });
            await loader.hide();
          }
          // Vue.toasted.show(data.message);
          loader.hide();
        } else {
          Vue.toasted.show(data.message);
          loader.hide();
        }
      })
      .catch(err => {
        // loader.hide();
        console.log("err :>> ", err);
        Vue.toasted.show("Catch error in payment:", err);
        loader.hide();
      });
  },
  bookSeats: async (context, payload) => {
    let loader = Vue.$loading.show();
    // console.log("payload.cust_id :", payload.cust_id);
    let guest_user_id = localStorage.getItem("guest_user_id")
      ? localStorage.getItem("guest_user_id")
      : null;
    let body = {
      reservation_id: store.getters.reservationId,
      payment_method: 1,
      cust_id:
        store.getters.login_details.length > 0 ? store.getters.login_details[0].cust_id : null,
      customer_id:
        store.getters.login_details.length > 0 ? store.getters.login_details[0].cust_id : null,
      guest_user_id: guest_user_id,
      email: payload.email,
      offer_setting_id:
        store.getters.selectedOffers && Object.keys(store.getters.selectedOffers).length > 0
          ? store.getters.selectedOffers.offer_setting_id
          : null,
      promocode: String(store.getters.promoCode).length > 0 ? store.getters.promoCode : null,
      offerFor: store.getters.offerFor,
      // offer: store.getters.offer,
      // applied_voucher: store.getters.applied_voucher,
      isGroupRateCard: true,
      payment_mode_id: 10,
      cinema_id: store.getters.schedule_details_obj.cine_id,
      aggregator_cinema: store.getters.schedule_details_obj.cine_id,
      payment_mode: {
        bs_id: 1,
        bs_source: "Box Office",
        bs_is_active: "Y",
        created_by: null,
        created_at: null,
        updated_by: 4,
        updated_at: "2020-07-16T04:20:00.000Z",
        bspm_id: 20,
        booking_source_id: 1,
        payment_mode_id: 3,
        mapping_is_active: "Y",
        pm_id: 3,
        pm_payment_mode: "Debit Card",
        pm_icon_url: null,
        pm_is_active: "Y",
        amount: 0
      },
      offer:
        store.getters.selectedOffers && Object.keys(store.getters.selectedOffers).length > 0
          ? store.getters.selectedOffers
          : {
              t_offer_price: 0,
              oc_discount_value: 0,
              is_on_net_amount: "N",
              is_offer_for: "vouchers",
              is_offer_applied: false,
              is_on_gross_amount: "N"
            },
      currency_code: store.getters.getGlobalCurrency.curr_code,
      country_mob_code: payload.country_mob_code,
      mobile_number: payload.cust_mobile
      // offer: {
      //   t_offer_price: 0,
      //   oc_discount_value: 0,
      //   is_on_net_amount: "N",
      //   is_offer_for: "vouchers",
      //   is_offer_applied: false,
      //   is_on_gross_amount: "N"
      // }
      // offer: {
      //     is_offer_applied:
      //         Object.keys(store.getters.selectedOffers).length > 0
      //             ? true
      //             : false,
      //     ...store.getters.selectedOffers,
      //     t_offer_price: store.getters.offerPrice,
      //     oc_discount_value: store.getters.offerPrice,
      //     is_on_net_amount: null,
      //     is_on_net_amount: null,
      //     is_offer_for: store.getters.offerFor,
      // }
      // totalTicketPrice: payload.totalTicketPrice
    };
    // if (store.getters.offerFor === "offersAndPromotions") {
    //     body.offer["is_on_net_amount"] =
    //         store.getters.selectedOffers["offer_applicable_on_net_amount"] ||
    //         "N";
    //     body.offer["is_on_gross_amount"] =
    //         store.getters.selectedOffers["offer_applicable_on_gross_amount"] ||
    //         "N";
    // }
    await MovieService.BookSeats(body)
      .then(async response => {
        const { data } = response;
        // loader.hide();
        if (data.status) {
          if (data.bookingID) {
            console.log("data.BookingId bookseats :", data.bookingID);
            await context.commit("SET_BOOKING_ID", data.bookingCode);
            await Vue.toasted.show("Seats Booked");
            await router.push({ path: "/booking-confirmation" });
            await store.dispatch("onResetOffersAndPrice");
            loader.hide();
            // await context.dispatch('getBookingDetails')
          }
          // Vue.toasted.show(data.message);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(err => {
        // loader.hide();
        console.log("err :>> ", err);
        Vue.toasted.show("Catch error in book seats", err);
      });
  },
  getBookingDetails({ state, commit }) {
    console.log("state.booking_id :", state.booking_id);
    MovieService.GetBookingDetails({
      bookingCode: state.booking_id
    })
      .then(response => {
        const { data } = response;
        // loader.hide();
        if (data.status) {
          if (data.Records) {
            console.log("data.Records :", data.Records);
            commit("SET_BOOKING_DETAILS", data.Records);
            commit("SET_SCHEDULE_DETAILS_OBJ", {});
          }
          Vue.toasted.show(data.message);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(err => {
        // loader.hide();
        Vue.toasted.show("Catch error in payment");
      });
  }
};

const getters = {
  booking_details: state => state.booking_details
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/checkoutStore.js